export default __webpack_public_path__ + "static/media/saint_aubin13.fa3e31c4.jpg";